<div class="p-6 bg-white rounded-xl shadow border max-w-xl">

  <h2 class="text-xl font-semibold mb-4 text-gray-800">
    Direct Stock Issue
  </h2>

  <!-- Barcode Input -->
  <!-- <input
  type="text"
  [(ngModel)]="barcode"
  (input)="onBarcodeInput()"
  (keydown.enter)="onScanComplete()"
  autofocus
  placeholder="Scan barcode here..."
  class="w-full border px-4 py-3 rounded-lg
         text-lg tracking-widest
         focus:ring-2 focus:ring-[#C19725]"
/> -->
<input
  type="text"
  [(ngModel)]="barcode"
  (keydown.enter)="onScanComplete()"
  autofocus
  class="w-full px-4 py-3 border rounded-lg text-lg tracking-widest"
/>

  <!-- Multiple matches fallback -->
  <ul *ngIf="suggestions.length > 1"
      class="mt-4 border rounded divide-y">

    <li *ngFor="let tag of suggestions"
        class="p-3 flex justify-between items-center">

      <div>
        <div class="font-medium">{{ tag.std_item_name }}</div>
        <div class="text-xs text-gray-500">{{ tag.std_barcode }}</div>
      </div>

      <button
        class="px-4 py-1.5 bg-c19725 text-white rounded"
        (click)="$any(this).issueStock(tag)">
        Issue
      </button>

    </li>
  </ul>

  <p *ngIf="barcode && suggestions.length === 0"
     class="mt-3 text-sm text-red-500">
    No pending stock found for this barcode
  </p>

</div>
